// extracted by mini-css-extract-plugin
module.exports = {"form_control":"CardCategoriesHeader_form_control__2bUx8","title":"CardCategoriesHeader_title__33Cxq","search_bg":"CardCategoriesHeader_search_bg__14gRr"};